import React from 'react';
import PropTypes from "prop-types";
import Button from "../../../button/Button";
import InfoIcon from "../../../icons/Info.icon";

export const InfoMessageContent = React.forwardRef((props, ref) => {
  const {
    message,
    onAcceptAction = () => {
      ref?.current && ref?.current.close()
    },
    title,
  } = props;

  return (
    <div style={{ width: '400px' }}>
      <div className="text-center"><InfoIcon/></div>
      <h3 className="modal-title text-center pt-1 pb-3">{title}</h3>
      <p className="text-center">{message}</p>
      <div className="d-flex justify-content-center p-2">
        <Button className="" label="Aceptar" onClick={onAcceptAction}/>
      </div>
    </div>
  );
});

InfoMessageContent.defaultProps = {
  title: '¡Ha ocurrido un error!',
  message: 'Intente nuevamente o contáctenos.',
  onAcceptAction: PropTypes.func,
};

InfoMessageContent.propTypes = {

};

export default React.memo(InfoMessageContent);
